// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nreu","field":"styles_field__D9lx5","fieldCol":"styles_fieldCol__39Dzx","diffCol":"styles_diffCol__2vfkC","diff":"styles_diff__1hXyu"};